module.exports = __webpack_public_path__ + "static/media/kelvin-logo.29dfa06b.png";